import { Text } from "@fluentui/react-components";
import React from "react";
import { useIntl } from "react-intl";

import { Flex } from "@tdp/common/fluentV9MigrationComponents";

import { IIntensityDataPoint } from "./IAnalyticsCharts";
import { useChartStyles } from "./utils";


export const ChartIntensity: React.FC<{ data: IIntensityDataPoint }> = ({ data }) => {
  const intl = useIntl();
  const classes = useChartStyles();
  return (
    <Flex className={classes.intensityStyles} column gap="gap.large">
      <Flex column>
        <Text size={600}>{data.median}</Text>
        <Text>{intl.formatMessage({
          defaultMessage: "Median days used per month",
          description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextMedianDays",
        })}</Text>
      </Flex>
      <Flex column>
        <Text size={600}>{data.percentage} {"%"}</Text>
        <Text>{intl.formatMessage({
          defaultMessage: "% of 5+ days usage",
          description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextPercentDays",
        })}</Text>
      </Flex>
      <Flex column>
        <Text size={600}>{data.mau} {"%"}</Text>
        <Text>{intl.formatMessage({
          defaultMessage: "DAU/MAU",
          description: "Name for the given metric row in the analytics page. For metric explanation see analyticsMetricTooltipTextRatio",
        })}</Text>
      </Flex>
    </Flex>
  );
};